import AssetDetailsDialouge from './components/AssetDetailsDialouge';
import Layout from './components/layout';
import AssetDetail from './components/oldFiles/AssetDetailsV4'

export default {
	Layout, AssetDetail, AssetDetailsDialouge
}